// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { showSuccess, showError } from '@calendly/alert';
import { Form, RadioGroupField, SubmitFormButton, useFormContext } from '@calendly/form';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { PageHeader } from '@calendly/ui/components/page-header';
import { Sheet } from '@calendly/ui/components/sheet';
import { TitleText, BodyText } from '@calendly/ui/components/typography';
import { useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { DirtyFormTracking } from 'components/core/form';
import LoadingState from 'components/core/loading_state';
import { useGetMeetingIntelligenceUserSettingsQuery, useUpdateOrganizationMeetingIntelligenceDataMutation } from 'features/meeting_intelligence';
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context';
const cardContainerCss = "c1595zjf";
const formFooterCss = "fz11jn";
const formCss = "f15jirc1";
const descriptionWrapperCss = "d1m7f0lp";
const NotetakerSettingsFormContent = () => {
  const {
    handleReset
  } = useFormContext();
  const options = [{
    label: I18n.t('publisher.organization_settings.notetaker_settings.everyone.title'),
    description: <div className={descriptionWrapperCss}>
          <BodyText color="muted">
            {I18n.t('publisher.organization_settings.notetaker_settings.everyone.subtitle')}
          </BodyText>
        </div>,
    value: 'everyone'
  }, {
    label: I18n.t('publisher.organization_settings.notetaker_settings.no_one.title'),
    description: <div className={descriptionWrapperCss}>
          <BodyText color="muted">
            {I18n.t('publisher.organization_settings.notetaker_settings.no_one.subtitle')}
          </BodyText>
        </div>,
    value: 'no_one'
  }];
  return <>
      <RadioGroupField name="notetaker_access" options={options} />
      <div className={formFooterCss}>
        <SubmitFormButton>
          {I18n.t('publisher.action.save_changes')}
        </SubmitFormButton>
        <Button decoration="secondary-outline" onClick={handleReset}>
          {I18n.t('publisher.action.cancel')}
        </Button>
      </div>
    </>;
};
const AccessControl = () => {
  const dispatch = useDispatch();
  const {
    data: meetingIntelligenceData,
    isFetching
  } = useGetMeetingIntelligenceUserSettingsQuery({}, {
    refetchOnMountOrArgChange: true
  });
  const [updateOrganizationSettings, {
    isSuccess,
    reset
  }] = useUpdateOrganizationMeetingIntelligenceDataMutation();
  const initialNotetakerAccess = useMemo(() => meetingIntelligenceData?.adminDisabledNotetaker ? 'no_one' : 'everyone', [meetingIntelligenceData]);
  useEffect(() => {
    if (isSuccess) {
      dispatch(showSuccess(I18n.t('publisher.flash.changes_saved')));
      reset();
    }
  }, [dispatch, isSuccess, reset]);
  const onSubmit = async (values, actions) => {
    const {
      notetaker_access: notetakerAccess
    } = values;
    const adminDisabledNotetaker = notetakerAccess === 'no_one';
    const result = await updateOrganizationSettings({
      adminDisabledNotetaker
    });
    if (result.error) {
      dispatch(showError(I18n.t('publisher.organization_settings.notetaker_settings.update_failure')));
      return;
    }
    actions?.resetForm?.({
      values
    });
  };
  if (isFetching) {
    return <LoadingState />;
  }
  return <Sheet className={cardContainerCss}>
      <FlexLayout direction="column">
        <TitleText level={3} size="medium" weight="semibold">
          {I18n.t('publisher.organization_settings.notetaker_settings.description')}
        </TitleText>
        <Form className={formCss} initialValues={{
        notetaker_access: initialNotetakerAccess
      }} onSubmit={onSubmit}>
          <DirtyFormTracking />
          <NotetakerSettingsFormContent />
        </Form>
      </FlexLayout>
    </Sheet>;
};
export const NotetakerSettingsPage = ({
  match
}) => {
  const pageTitle = `${I18n.t('publisher.admin.navigation.notetaker_settings')}`;
  const inSettingsModal = useIsSettingsModalLayout();
  usePageTitle(pageTitle);
  return <>
      {!inSettingsModal && <PageHeader eyebrow={<TitleText variant="eyebrow">
              {I18n.t('publisher.admin.navigation.notetaker_settings')}
            </TitleText>} title={I18n.t('publisher.admin.navigation.notetaker_access')} />}
      <Switch>
        <Redirect exact from="/app/admin/notetaker" to="/app/admin/notetaker/access" />
        <Route path={`${match.url}/access`} component={AccessControl} />
      </Switch>
    </>;
};

require("./notetaker_settings.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_settings.js");